// extracted by mini-css-extract-plugin
export default {"body":"input-messages__body___xkW9m","error":"input-messages__error___38n6k","info":"input-messages__info___1HHpE"};